import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
    selector: 'event-setting-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class EventTypeFormDialogComponent implements OnInit
{
  public formGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required)
  });
  action: string;
  dialogTitle;
  eventType;
  choosenColor;
    constructor(
        public dialogRef: MatDialogRef<EventTypeFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
    )
    {
        this.action = data.action;

        if ( this.action === 'edit' )
        {
            this.dialogTitle = 'eventType.edit';
            this.eventType = data.type;
        }
        else
        {
            this.dialogTitle = 'eventType.new';
        }
    }

    ngOnInit()
    {
      if (this.action === 'edit') {
        this.formGroup.patchValue(this.eventType);
        this.choosenColor = this.eventType.color;
      }
    }

  onSettingsChange(event) {
      this.choosenColor = event.bg;
  }

}
